// extracted by mini-css-extract-plugin
module.exports = {"post_overview_footer":"postOverviewFooter-module--post_overview_footer--1RAFy"};